import { connect } from 'react-redux';

import { fetchNews } from 'client/ducks/news/actions';
import { getNews, isLoading } from 'client/ducks/news/selectors';
import { State } from 'client/store';

import News, { DispatchProps, StateProps } from './news';
import { AsyncFetchDataProps } from '@interfaces/async-fetch-data';

function mapStateToProps(state: State): StateProps {
    return {
        data: getNews(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = { fetchNews };

const component = connect<StateProps, DispatchProps>(
    mapStateToProps,
    mapDispatchToProps
)(News) as any;

component.asyncFetchData = ({ dispatch, match }: AsyncFetchDataProps) => {
    return dispatch(fetchNews(match.params.slug));
};

export default component;
